module.exports = __webpack_public_path__ + "static/media/tour-5.93ac8704.jpg";